import { useTranslation } from 'react-i18next';
import { LocalizedLink } from './LocalizedLink';
import type { ProductModel } from '../data/products';

/**
 * 产品卡片 —— 复现原网站 js/products-filter.js 的渲染逻辑：
 * 图片 + 型号名 + specs(accuracy / axis-Axis / interface) + 描述 + 按钮
 */
export function ProductCard({ product }: { product: ProductModel }) {
  const { t } = useTranslation('common');

  const specs: string[] = [];
  if (product.accuracy) specs.push(product.accuracy);
  if (product.axis) specs.push(`${product.axis}-Axis`);
  if (product.interface) specs.push(product.interface);

  // 详情链接：指向具体型号详情页 /products/{category}/{id}
  const detailPath = `/products/${product.category}/${product.id}`;

  // 本地化描述：有翻译用翻译，否则回退英文描述
  const description = t(`products:descriptions.${product.id}`, { defaultValue: product.description });

  return (
    <article className="flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-panel">
      <div className="flex h-44 items-center justify-center bg-slate-50 p-4">
        <img src={product.image} alt={product.name} loading="lazy" className="max-h-full object-contain" />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="text-lg font-bold leading-snug text-ink">
          <LocalizedLink to={detailPath} className="hover:text-aqua">
            {product.name}
          </LocalizedLink>
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {specs.map((s) => (
            <span key={s} className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
              {s}
            </span>
          ))}
        </div>
        <p className="mt-3 flex-1 text-sm leading-6 text-slate-600">{description}</p>
        <div className="mt-4 flex gap-3">
          <LocalizedLink to={detailPath} className="btn-secondary px-4 py-2 text-sm">
            {t('actions.learnMore')}
          </LocalizedLink>
          <LocalizedLink to="/contact" className="btn-primary px-4 py-2 text-sm">
            {t('actions.getQuote')}
          </LocalizedLink>
        </div>
      </div>
    </article>
  );
}
